﻿import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";

import classes from "../Inventory/inventory.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const EmptyContainerFilter = ({ defaultUnit, date, dateTo, showAll, applyFilter }) => {
	const [defaultUnitFilter, setDefaultUnitFilter] = useState(defaultUnit);
	const [dateFilter, setDateFilter] = useState(date);
	const [dateToFilter, setDateToFilter] = useState(dateTo);
	const [showAllFilter, setShowAllFilter] = useState(showAll);

	const handleApplyFilter = () => {
		applyFilter({
			defaultUnitFilter,
			dateFilter,
			dateToFilter,
			showAllFilter,
		});
	};

	const handleCleanFilter = () => {
		applyFilter({
			defaultUnitFilter: 1000,
			dateFilter: "",
			dateToFilter: "",
			showAllFilter: false,
		});
	};

	const baseUnits = [
		{ value: 1, label: "g - cc" },
		{ value: 1000, label: "Kg - L" },
		{ value: 10000, label: "Tn - KL" },
	];

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr style={{ marginTop: "0.5em", marginBottom: "0.5em" }} />

			<div className={classes.divContent}>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Unidad de Medida</span>
					</Col>
					<Col md={12}>
						<Select
							value={baseUnits && baseUnits.filter((b) => Number(b.value) === Number(defaultUnitFilter))}
							placeholder={<div>Seleccione</div>}
							options={baseUnits ? baseUnits : []}
							onChange={(value) => setDefaultUnitFilter(value.value)}
							components={{ NoOptionsMessage }}
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Fecha Ingreso</span>
					</Col>
					<Col md={12}>
						<small>Desde</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateFilter}
							onChange={(e) => setDateFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
					<Col md={12}>
						<small>Hasta</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateToFilter}
							onChange={(e) => setDateToFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Ver Todos los envases</span>
					</Col>
					<Col md={12} style={{ textAlign: "center", marginBottom: "10px" }}>
						<CustomInputSwitch
							value={showAllFilter}
							optionLeft="NO"
							optionRight="SI"
							onChange={(checked) => {
								setShowAllFilter(checked ? 1 : 0);
							}}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default EmptyContainerFilter;
